module.exports = ".blue {\n  background-color: #c3c9dc !important; }\n"